import { sva } from "@agapi/ui/panda/css";
import { anatomy } from "@zag-js/checkbox";
export const checkboxStyles = sva({
    slots: anatomy.extendWith("count").keys(),
    base: {
        root: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "3",
            p: "3",
            borderRadius: "0",
            cursor: "pointer",
            transition: "0.18s ease",
            _hover: { bg: "surface.subdued.background" },
            _highlighted: {
                bg: "surface.subdued.background",
            },
            _focus: {
                bg: "surface.subdued.background",
                outline: "2px solid token(colors.forms.action)",
                outlineOffset: "2px",
                borderRadius: "2px",
            },
            _checked: {
                bg: "surface.primary.subdued.background",
                "&:hover": {
                    bg: "surface.primary.tonal.background",
                },
                _focus: {
                    bg: "surface.primary.subdued.background",
                },
                "&[data-highlighted]": {
                    bg: "surface.primary.tonal.background",
                },
            },
            _disabled: {
                color: "text.subdued",
                pointerEvents: "none",
                userSelect: "none",
                _checked: {
                    bg: "none",
                },
            },
            _invalid: {
                color: "feedback.error.foreground",
            },
        },
        label: {
            flex: 1,
        },
        count: {
            fontSize: "xs",
            color: "text.subdued"
        },
        control: {
            display: "flex",
            alignItems: "center",
            position: "relative",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "borders.base",
            borderRadius: "2",
            width: "18px",
            aspectRatio: "1/1",
            overflow: "hidden",
            transition: "0.1s ease",
            _hover: {
                borderColor: "forms.action",
            },
            _before: {
                content: '""',
                position: "absolute",
                backgroundColor: "forms.action",
                borderRadius: 999,
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
                scale: 0,
                transition: "0.18s ease-out",
                opacity: 0,
            },
            "[data-state='checked'] &": {
                borderColor: "forms.action",
                _before: {
                    scale: 1.3,
                    opacity: 1,
                }
            },
            "[data-disabled] &": {
                borderColor: "action.disabled.foreground",
            },
            "[data-disabled][data-state='checked'] &": {
                _before: {
                    backgroundColor: "action.disabled.foreground",
                }
            },
            _invalid: {
                borderColor: "feedback.error.border",
                borderWidth: "2px",
                _hover: {
                    borderColor: "feedback.error.border",
                },
            },
        },
        indicator: {
            width: "100%",
            aspectRatio: "1/1",
            transition: "0.18s ease-out",
            color: "white",
            opacity: "0",
            scale: "0.66",
            transform: "rotate(-45deg)",
            "[data-state='checked'] &": {
                opacity: "1",
                scale: "1",
                transform: "rotate(0deg)",
            },
        },
    },
    variants: {
        disabled: {
            true: {
                control: {
                    borderColor: "action.disabled.foreground",
                },
                checkmark: {
                    color: "action.disabled.foreground",
                },
            },
        },
    },
});
